import { FolderSwapIcon } from '@tableau/icons/FolderSwapIcon';

import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { ContentRelayPlanFieldValuesQuery } from '~src/contentRelay/ResourceQuery/ContentRelayPlanFieldValuesQuery';
import { ContentRelayPlansResourceQuery } from '~src/contentRelay/ResourceQuery/ContentRelayPlansResourceQuery';
import { ContentRelayPlanCard } from '~src/contentRelay/space/ContentRelayPlanCard';
import {
  ContentTypeFilterClause,
  ExplorableItemDefinition,
  SpaceDefinition,
} from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { getNoDefaultFilters } from '~src/spacesPlatform/contentDefinitions/getDefaultFilters';
import { ContentFiltersKeys } from '~src/spacesPlatform/models/ContentFilters';

export const ContentRelayPlanDefinition: SpaceDefinition<'contentRelayPlan'> & ExplorableItemDefinition = {
  itemType: 'contentRelayPlan',
  contentType: 'contentRelayPlan',
  singularName: Messages.contentRelayPlan,
  pluralName: Messages.contentRelayPlans,
  emptyStateMessage: Messages.contentRelayPlansEmptyMessage,
  contentFilterKeys: [
    // Applied client-side by ContentRelayPlansResourceQuery. The owner typeahead's values come from
    // ContentRelayPlanFieldValuesQuery, since getFieldValues doesn't know Content Relay plans.
    ContentFiltersKeys.search,
    ContentFiltersKeys.owner,
    ContentFiltersKeys.createdAfter,
    ContentFiltersKeys.createdBefore,
    ContentFiltersKeys.modifiedAfter,
    ContentFiltersKeys.modifiedBefore,
  ],
  defaultFilters: getNoDefaultFilters,
  cardComponent: ContentRelayPlanCard,
  listViewIconType: FolderSwapIcon,
  filterClause: ServerFilterClauses.ContentType(['contentRelayPlan']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return new ContentRelayPlansResourceQuery();
  },
  getContentInfo: () => {
  },
  getFieldValuesQuery: (filterField) => new ContentRelayPlanFieldValuesQuery(filterField),
  supportedDisplayModes: ['list', 'thumbnail'],
  contentSpaceUrl: (urls, _contentId, luid) => urls.contentRelayPlanUrl(luid),
  headerIconPath: () => undefined,
};
